// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wsuF","select":"styles_select__2Dn7Q"};